module.exports = __webpack_public_path__ + "img/step-1.aa6d08d9.jpg";